const paymentPubSubEventNamespace = "payment";
const paymentPubSubEventTypeNames = [
    "fulfilled",
    "failed",
    "pending",
    "refund_fulfilled",
    "refund_failed",
    "refund_pending",
    "ping_pong",
] as const;
type PaymentPubSubEventTypeName = (typeof paymentPubSubEventTypeNames)[number];

export type { PaymentPubSubEventTypeName };
export { paymentPubSubEventNamespace, paymentPubSubEventTypeNames };
